// extracted by mini-css-extract-plugin
export default {"container":"styles_container__Zfxdj","deck":"styles_deck__+gDpi","trailsText":"styles_trailsText__VOHJJ"};